// Formatting for the admin-only per-turn diagnostics line (site-assistant SA23).
// The server sends the "debug" event only to admins (isAiDebugAllowed).

import { providerForModelId, type AiChatEvent } from "@checklist/shared";

export type AiDebugInfo = Extract<AiChatEvent, { type: "debug" }>;

/** `anthropic.claude-haiku-4-5` / `us.anthropic.claude-haiku-4-5-20251001-v1:0` -> `Haiku 4.5`. */
export function shortModelName(modelId: string): string {
  const match = /claude-(haiku|sonnet|opus|fable)-(\d+)(?:-(\d{1,2}))?(?!\d)/i.exec(modelId);
  if (!match) return modelId;
  const family = match[1]!.charAt(0).toUpperCase() + match[1]!.slice(1).toLowerCase();
  return match[3] ? `${family} ${match[2]}.${match[3]}` : `${family} ${match[2]}`;
}

const count = new Intl.NumberFormat("en-US");

export function formatCount(n: number): string {
  return count.format(n);
}

export function formatCostUsd(usd: number): string {
  return usd < 0.01 ? "<$0.01" : `$${usd.toFixed(3)}`;
}

export function formatSeconds(ms: number): string {
  return `${(ms / 1_000).toFixed(1)} s`;
}

export function formatDebugSummary(d: AiDebugInfo): string {
  return [
    shortModelName(d.modelId),
    `${formatCount(d.inTokens)} in / ${formatCount(d.outTokens)} out`,
    `cache ${formatCount(d.cacheReadTokens)} read / ${formatCount(d.cacheCreationTokens)} write`,
    formatSeconds(d.durationMs),
    formatCostUsd(d.estCostUsd),
    providerForModelId(d.modelId) === "anthropic" ? "API" : "Bedrock",
  ].join(" · ");
}
